import { Box, Typography } from '@mui/material';

interface TopbarProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
  /** Optional node rendered to the left of the title (e.g. a logo mark). */
  leading?: React.ReactNode;
}

export const Topbar = ({ title, subtitle, actions, leading }: TopbarProps) => {
  return (
    <Box
      component="header"
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'flex-start', sm: 'center' },
        justifyContent: 'space-between',
        gap: { xs: 1.5, sm: 2 },
        mb: { xs: 2, sm: 3 },
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: { xs: 1.25, sm: 1.75 } }}>
        {leading && <Box sx={{ display: 'flex', alignItems: 'center', flexShrink: 0 }}>{leading}</Box>}
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h4"
            component="h1"
            sx={{
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: 'text.primary',
              fontSize: { xs: '1.5rem', sm: '2rem', md: '2.125rem' },
              lineHeight: 1.2,
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              variant="body2"
              sx={{
                mt: { xs: 0.25, sm: 0.5 },
                color: 'text.secondary',
                fontSize: { xs: '0.8125rem', sm: '0.875rem' },
              }}
            >
              {subtitle}
            </Typography>
          )}
        </Box>
      </Box>
      {actions && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 0.75, sm: 1 },
            flexWrap: 'wrap',
            width: { xs: '100%', sm: 'auto' },
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
          }}
        >
          {actions}
        </Box>
      )}
    </Box>
  );
};

export default Topbar;
